var React = require('react');

function PhotoCollage (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21 13c.55 0 1 .45 1 1v7c0 .55-.45 1-1 1h-7c-.55 0-1-.45-1-1v-7c0-.55.45-1 1-1h7zM10 2c.55 0 1 .45 1 1v18c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h7zm11 0c.55 0 1 .45 1 1v7c0 .55-.45 1-1 1h-7c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h7z","fillRule":"evenodd"}));
}

PhotoCollage.defaultProps = {"width":"24","height":"24"};

module.exports = PhotoCollage;

PhotoCollage.default = PhotoCollage;
